"use client";

import type React from "react";

import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { CheckCircle, Loader2 } from "lucide-react";

export function ContactForm() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Simulate form submission
    await new Promise((resolve) => setTimeout(resolve, 1500));

    setIsSubmitting(false);
    setIsSubmitted(true);
  };

  if (isSubmitted) {
    return (
      <div className="flex flex-col items-center justify-center py-12 text-center">
        <div className="bg-green-100 rounded-full p-3 mb-4">
          <CheckCircle className="h-12 w-12 text-green-600" />
        </div>
        <h3 className="text-xl font-bold mb-2">Yêu cầu đã được gửi!</h3>
        <p className="text-gray-600 mb-6">
          Cảm ơn bạn đã liên hệ. Đội ngũ của chúng tôi sẽ phản hồi trong thời
          gian sớm nhất.
        </p>
        <Button variant="outline" onClick={() => setIsSubmitted(false)}>
          Gửi yêu cầu khác
        </Button>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} id="contact-form" className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="space-y-2">
          <Label htmlFor="fullName">Họ và tên</Label>
          <Input id="fullName" placeholder="Nhập họ và tên" required />
        </div>
        <div className="space-y-2">
          <Label htmlFor="company">Tên công ty</Label>
          <Input id="company" placeholder="Nhập tên công ty" required />
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="space-y-2">
          <Label htmlFor="email">Email</Label>
          <Input
            id="email"
            type="email"
            placeholder="example@company.com"
            required
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="phone">Số điện thoại</Label>
          <Input id="phone" placeholder="0xxxxxxxxx" required />
        </div>
      </div>

      <div className="space-y-2">
        <Label htmlFor="service">Dịch vụ quan tâm</Label>
        <Select>
          <SelectTrigger>
            <SelectValue placeholder="Chọn dịch vụ" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="erp-implementation">Triển khai ERP</SelectItem>
            <SelectItem value="erp-consulting">Tư vấn giải pháp ERP</SelectItem>
            <SelectItem value="erp-training">Đào tạo sử dụng ERP</SelectItem>
            <SelectItem value="erp-support">Hỗ trợ kỹ thuật</SelectItem>
            <SelectItem value="erp-upgrade">Nâng cấp hệ thống ERP</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div className="space-y-2">
        <Label htmlFor="message">Nội dung</Label>
        <Textarea
          id="message"
          placeholder="Mô tả nhu cầu của doanh nghiệp bạn..."
          className="min-h-[120px]"
          required
        />
      </div>

      <Button
        type="submit"
        className="w-full bg-gradient-to-r from-indigo-500 to-purple-500 hover:from-indigo-600 hover:to-purple-600"
        disabled={isSubmitting}
      >
        {isSubmitting ? (
          <>
            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            Đang gửi...
          </>
        ) : (
          "Gửi Yêu Cầu"
        )}
      </Button>
    </form>
  );
}
